import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { NewImportExportService } from '../../../_service/new-import-export.service';
import { ImportExportService } from 'src/app/client-management/import-export';
import { ToastrService } from 'ngx-toastr';


@Component({
  selector: 'app-auto-send-delete',
  templateUrl: './auto-send-delete.component.html',
  styleUrls: ['./auto-send-delete.component.css']
})
export class AutoSendDeleteComponent implements OnInit {

  isDeleting = false;

  constructor(
    public dialogRef: MatDialogRef<AutoSendDeleteComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private service: ImportExportService,
    private importExportService: NewImportExportService,
    private toastr: ToastrService,
  ) { }

  ngOnInit(): void {
  }

  onCancel(): void {
    if (this.isDeleting) {
      return;
    }
    this.dialogRef.close(false);
  }

  onConfirm(): void {
    if (this.isDeleting) {
      return;
    }

    this.isDeleting = true;

    this.service.delete(this.data.rapport.id).subscribe(
      () => {
        this.importExportService.deleteRapport(this.data.rapport.id);
        this.toastr.success('Rapport supprimé avec succès !', 'Succès');
        this.dialogRef.close(true);
      },
      (error) => {
        console.error('Erreur lors de la suppression du rapport :', error);
        this.toastr.error('Une erreur est survenue lors de la suppression ', 'Erreur');
        this.isDeleting = false;
      }
    );
  }

}